import { gql } from "@apollo/client";

import ArtifactComponentFragment from "@apps/artifact/graphql/artifact-component-fragment";

export default gql`
  ${ArtifactComponentFragment}
  query getArtifactComponentQuery($artifactId: Int!) {
    artifact(artifactId: $artifactId) {
      __typename
      ...ArtifactComponentFragment
    }
  }
`;
